import { createFileRoute, redirect } from '@tanstack/react-router'

import { DIALOG_PATHS } from '~/lib/dialogs'

/**
 * The address settings' videos section wears while it is open — the same mask over the page
 * underneath as every section's, caught here when the address arrives on its own.
 */
export const Route = createFileRoute('/settings_/videos')({
  beforeLoad: () => {
    redirect({
      to: '/',
      search: { dialog: 'videos' },
      throw: true,
      mask: { to: DIALOG_PATHS.videos },
    })
  },
})
